// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2918":"11c8ce99","5738":"11c8ce99","7053":"173e0059","9861":"d46cab61"}[chunkId] + ".chunk.css";
};